import React from "react";
import {Swiper, SwiperSlide} from 'swiper/react'
import { Pagination } from "swiper/modules";
import psychologyImage from "../img/Поиск-себя.png";
import educationImage from "../img/Потенциал.png";
import productionImage from "../img/Инклюзивные-дети.png";
import liveImage from '../img/Пожилые.png'
import wayOutImage from '../img/Зависимости.png'
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";



export const Project = () => {
  const project = [
    {
      name: "Найди себя!",
      img: psychologyImage,
      job: "Программа предназначена для тех, кто ищет свое истинное «Я». Мы предлагаем поддержку в раскрытии внутренних ресурсов, желаний, предпочтений. Программа включает индивидуальные занятия, групповые сессии, направленные на осознание своих целей, путей их достижения.",
    },
    {
      name: "Сотвори себя!",
      img: educationImage,
      job: "Проект способствует развитию творческой индивидуальности. Мы работаем над определением уникального стиля, привлекательного творческого образа. В рамках программы проводятся мастер-классы и консультации с профессионалами, которые помогают выявить созидательные потенциалы.",
    },
    {
      name: "Инклюзивные дети!",
      img: productionImage,
      job: "Многопрофильная программа для детей, которая учитывает их индивидуальные особенности и состояние здоровья. В рамках проекта мы предлагаем поддержку не только детям, но и их родителям, предоставляем ресурсы, подходящие методики для полноценного развития, помощи в адаптации к изменениям.",
    },
    {
      name: "Жить, а не доживать!",
      img: liveImage,
      job: "Программа для лиц старше 50 лет, направленная на поддержание активной, полноценной жизни. Мы оказываем психологическую помощь для предпенсионеров, пожилых людей и тех, кто хочет справиться с вызовами старения и наслаждаться каждым днем.",
    },
    {
      name: "Выход есть!",
      img: wayOutImage,
      job: "Комплексная программа помощи людям, страдающим от зависимостей. Предлагаем профессиональную поддержку и ресурсы для освобождения от зависимостей, независимо от их природы. Помогаем людям вернуться к полноценной жизни.",
    },
  ]

  return (
    <section id="projects" className="text-center" >
      <div className="container">
          <div className="section-title text-center">
            <h2>Проекты</h2>
            <div className="project-text-block">
              <p>
                Мы понимаем, как важно каждому человеку найти свой путь, реализовать потенциал, <br />
                поэтому предлагаем познакомиться с проектами:
              </p>
            </div>
          </div>
          <Swiper
            className="custom-swiper"
            modules={[Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            style={{ width: "100%", height: "500px" }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
          {project.map((project, index) => (
            <SwiperSlide key={index}>
              <div className="project-card">
                <img src={project.img} alt={project.name} className="project-image" />
                <h3 className="project-title">{project.name}</h3>
                <p className="project-description">{project.job}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="project-text-block">
        <p>
          Каждый проект Центра Психологии направлен на поддержку и вдохновение на важных этапах жизни людей. <br />
          Мы верим в уникальность каждого, готовы помочь в открытии новых горизонтов!
        </p>
      </div>
    </section>
  );
};
